export const itemsModesOptions: {name: string, value: string}[] = [
  {name: 'units', value: 'units'},
  {name: 'percentages', value: 'percentages'},
];